module.exports = __webpack_public_path__ + "img/choose-up-Up Social Masa Calda-disabled.f62e6853.png";